import {Injectable} from "@angular/core";
import {CoreApiService} from "../../core/service/core-api.service";
import {ApiResponseDto} from "../../core/interfaces/core.types";
import {
  ForgotPasswordDto,
  ForgotPasswordRequestDto,
  RegistrationDto, RegistrationFinishResult,
  RegistrationRequestOtpDto
} from "../types/registration.types";
import {Observable} from "rxjs";

@Injectable({ providedIn: 'root' })
export abstract class RegistrationApiService {

  endPoint: string = "mvseureg/eu/registration"

  referralGuid: string | undefined;



  constructor(
    protected coreApiService: CoreApiService) {
  }

  public setReferralGuid(referralGuid: string) {
    this.referralGuid = referralGuid;
  }

  /**
   * Request OTP Code.
   * @param phoneNumber
   */
  public requestOtp(phoneNumber: string) : Observable<ApiResponseDto> {

    const otpRequest: RegistrationRequestOtpDto = {
      phoneNumber: phoneNumber,
      deviceInfo: this.coreApiService.getDeviceInfo()
    };

    return this.coreApiService.post(otpRequest, `${this.endPoint}/requestOtp`);

  }

  public confirmOtp(phoneNumber: string, otpCode: string): Observable<RegistrationDto & ApiResponseDto> {

    const otpRequest: RegistrationRequestOtpDto = {
      phoneNumber: phoneNumber,
      otpCode: otpCode,
      deviceInfo: this.coreApiService.getDeviceInfo()
    };

    return this.coreApiService.post(otpRequest, `${this.endPoint}/confirmOtp`);
  }

  public get(dto: RegistrationRequestOtpDto): Observable<RegistrationDto> {
    return this.coreApiService.get(`${this.endPoint}/get`);
  }

  public setPictureBase64(dto: RegistrationRequestOtpDto): Observable<ApiResponseDto> {
    return this.coreApiService.post(dto, `${this.endPoint}/setPicture`);
  }

  public delPicture(dto: RegistrationRequestOtpDto): Observable<ApiResponseDto> {
    return this.coreApiService.post(dto, `${this.endPoint}/delPicture`);
  }

  public update(dto: RegistrationRequestOtpDto): Observable<RegistrationDto> {
    dto.referralGuid = this.referralGuid;
    return this.coreApiService.post(dto, `${this.endPoint}/update`);
  }

  public finish(dto: RegistrationRequestOtpDto): Observable<RegistrationDto> {
    return this.coreApiService.post(dto, `${this.endPoint}/finish`);
  }

  public finishAndLogin(dto: RegistrationRequestOtpDto): Observable<RegistrationFinishResult> {
    // we need to add the device Info
    dto.deviceInfo = this.coreApiService.getDeviceInfo();
    dto.referralGuid = this.referralGuid;
    return this.coreApiService.post(dto, `${this.endPoint}/finishAndLogin`);
  }

  public checkEmail(dto: RegistrationRequestOtpDto): Observable<RegistrationDto & ApiResponseDto> {
    return this.coreApiService.post(dto, `${this.endPoint}/checkEmail`);
  }

  public checkPassword(dto: RegistrationRequestOtpDto): Observable<RegistrationDto & ApiResponseDto> {
    return this.coreApiService.post(dto, `${this.endPoint}/checkPassword`);
  }


  public requestForgotPasswordOptions(dto: ForgotPasswordRequestDto): Observable<ApiResponseDto & ForgotPasswordDto> {
    return this.coreApiService.post(dto, `${this.endPoint}/requestForgotPasswordOptions`);
  }

  public requestForgotPasswordOtp(dto: ForgotPasswordRequestDto): Observable<ApiResponseDto> {
    return this.coreApiService.post(dto, `${this.endPoint}/requestForgotPasswordOtp`);
  }

  public checkForgotPasswordOtp(dto: ForgotPasswordRequestDto): Observable<ApiResponseDto> {
    return this.coreApiService.post(dto, `${this.endPoint}/checkForgotPasswordOtp`);
  }

  public changeForgotPasswordViaOtp(dto: ForgotPasswordRequestDto): Observable<ApiResponseDto> {
    return this.coreApiService.post(dto, `${this.endPoint}/changeForgotPasswordViaOtp`);
  }

}
